/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locationGroupId, locationGroup) => ({
    type: actions.EDIT_LOCATION_GROUP,
    payload: {
        id: locationGroupId,
        locationGroup,
    },
});